import styled from 'styled-components'

export const FullPagesStyle = styled.div`
    position: relative;
    display: flex;
    align-itens: center;
    flex-direction: column;
    overflow: hidden;
`;